import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import { useDispatch } from 'react-redux';
import api from '../../api';
import axios from 'axios';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/fideltycard/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/fideltycard/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/fideltycard/LOAD_FAILURE';

const LOAD_POINTS_REQUEST = 'farmakom/fideltycard/LOAD_POINTS_REQUEST';
const LOAD_POINTS_SUCCESS = 'farmakom/fideltycard/LOAD_POINTS_SUCCESS';
const LOAD_POINTS_FAILURE = 'farmakom/fideltycard/LOAD_POINTS_FAILURE';

const LOAD_ACTIVE_COUPONS_REQUEST =
  'farmakom/fideltycard/LOAD_ACTIVE_COUPONS_REQUEST';
const LOAD_ACTIVE_COUPONS_SUCCESS =
  'farmakom/fideltycard/LOAD_ACTIVE_COUPONS_SUCCESS';
const LOAD_ACTIVE_COUPONS_FAILURE =
  'farmakom/fideltycard/LOAD_ACTIVE_COUPONS_FAILURE';

const ACTIVATE_COUPON_REQUEST = 'farmakom/fideltycard/ACTIVATE_COUPON_REQUEST';
const ACTIVATE_COUPON_SUCCESS = 'farmakom/fideltycard/ACTIVATE_COUPON_SUCCESS';
const ACTIVATE_COUPON_FAILURE = 'farmakom/fideltycard/ACTIVATE_COUPON_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadFideltyCard() {
  return {
    [RSAA]: {
      ...api.getFideltyCoupons(),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

export function loadFideltyPoints() {
  return {
    [RSAA]: {
      ...api.getFideltyPoints(),
      types: [LOAD_POINTS_REQUEST, LOAD_POINTS_SUCCESS, LOAD_POINTS_FAILURE],
    },
  };
}

export function loadActiveCoupons() {
  return {
    [RSAA]: {
      ...api.getActiveCoupons(),
      types: [
        LOAD_ACTIVE_COUPONS_REQUEST,
        LOAD_ACTIVE_COUPONS_SUCCESS,
        LOAD_ACTIVE_COUPONS_FAILURE,
      ],
    },
  };
}

export const activateFidelityCoupon = couponId => {
  return async (dispatch, getState) => {
    dispatch({
      type: ACTIVATE_COUPON_REQUEST,
    });
    try {
      const { url, method, headers } = api.insertFidelityCoupon(couponId);
      const storeid = getState().store.data.storeId;

      const headersWithStoreId = {
        ...headers,
        storeid,
      };
      const response = await axios({
        url,
        method,
        headers: headersWithStoreId,
      });
      if (response) {
        dispatch({
          type: ACTIVATE_COUPON_SUCCESS,
          payload: response.data.point,
        });
        dispatch({
          type: LOAD_ACTIVE_COUPONS_SUCCESS,
          payload: response.data.userFidelityCoupons,
        });
      } else {
        dispatch({
          type: ACTIVATE_COUPON_FAILURE,
          payload: "Couldn't load events",
        });
      }
    } catch (error) {
      console.error('Error loading events', error);
      dispatch({
        type: ACTIVATE_COUPON_FAILURE,
        payload: error,
      });
    }
  };
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: [],
  coupons: [],
  points: 0,
};

export default function fideltyCardReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case LOAD_POINTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_POINTS_SUCCESS:
      return {
        ...state,
        loading: false,
        points: action.payload,
        error: null,
      };
    case LOAD_POINTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case ACTIVATE_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTIVATE_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        points: action.payload,
        error: null,
      };
    case ACTIVATE_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case LOAD_ACTIVE_COUPONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_ACTIVE_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.payload,
        error: null,
      };
    case LOAD_ACTIVE_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}
